import React from 'react';
import { useLang } from '../contexts/LangContext';
import { useTheme } from '../contexts/ThemeContext';

// Wspolny przelacznik PL/EN + jasny/ciemny dla calej strony publicznej Gap Assessment (11.08).
// Stylowany WYLACZNIE przez var(--token) (nigdy literalny hex/rgba) - omija normalize-style-attrs.js
// (postbuild), ktory normalizuje TYLKO literalne kolory odbite przez CSSOM Chrome, nie referencje
// var(...). Dzieki temu jeden komponent dziala bez zmian wewnatrz kazdej z 6 osobno izolowanych
// palet stron (.galp/.legalp) - patrz plan. Wzorzec piguly PL/EN 1:1 skopiowany z TermsPage.jsx
// (juz sprawdzony na produkcji), dopisany drugi przycisk motywu.
export default function PublicToggleBar({ style, className }) {
  const { lang, setLang } = useLang();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const themeTitle = isDark
    ? (lang === 'en' ? 'Switch to light theme' : 'Przelacz na jasny motyw')
    : (lang === 'en' ? 'Switch to dark theme' : 'Przelacz na ciemny motyw');

  return (
    <div className={className} style={{ display: 'flex', alignItems: 'center', gap: 8, ...style }}>
      <div style={{ display: 'flex', border: '1px solid var(--line)', borderRadius: 8, overflow: 'hidden', fontSize: '0.75rem', fontWeight: 700, flex: 'none' }}>
        <button
          type="button" onClick={() => setLang('pl')} aria-pressed={lang === 'pl'}
          style={{ background: lang === 'pl' ? 'var(--accent)' : 'transparent', color: lang === 'pl' ? 'var(--accent-ink)' : 'var(--ink-soft)', border: 'none', padding: '4px 10px', cursor: 'pointer' }}
        >PL</button>
        <button
          type="button" onClick={() => setLang('en')} aria-pressed={lang === 'en'}
          style={{ background: lang === 'en' ? 'var(--accent)' : 'transparent', color: lang === 'en' ? 'var(--accent-ink)' : 'var(--ink-soft)', border: 'none', padding: '4px 10px', cursor: 'pointer' }}
        >EN</button>
      </div>
      <button
        type="button" onClick={toggleTheme} title={themeTitle} aria-label={themeTitle}
        style={{
          width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: '1px solid var(--line)', borderRadius: 8, background: 'var(--paper-raised)',
          color: 'var(--ink-soft)', cursor: 'pointer', fontSize: '0.85rem', lineHeight: 1, flex: 'none', padding: 0,
        }}
      >{isDark ? '\u{1F319}' : '☀️'}</button>
    </div>
  );
}
